export default __webpack_public_path__ + "static/media/property_694.7be48641.png";